import { Typography, TypographyProps } from '@mui/material';
import { Variant } from '@mui/material/styles/createTypography';
import React, { FC, ReactNode, JSX } from 'react';
import styles from './AppTypography.module.scss';

export interface AppTypographyProps extends TypographyProps {
	bold?: boolean;
	children?: ReactNode;
	className?: string;
	color?: string;
	element?: Variant;
	gutterBottom?: boolean;
	noWrap?: boolean;
	preFormatted?: boolean;
	showLines?: boolean;
	style?: React.CSSProperties;
	text?: string | JSX.Element[] | JSX.Element;
	textAlign?: 'left' | 'center' | 'right' | 'justify';
	textOverflow?: 'clip' | 'ellipsis' | 'inherit' | 'initial' | 'unset' | 'revert' | 'revert-layer';
}

export const AppTypography: FC<AppTypographyProps> = ({
	bold = false,
	children,
	className = '',
	color = 'text.primary',
	element = 'body1',
	gutterBottom,
	preFormatted = false,
	showLines = false,
	style,
	text,
	textAlign = 'center',
	textOverflow,
	...rest
}) => {
	return (
		<Typography
			variant={element}
			color={color}
			textAlign={textAlign}
			className={[
				styles['header'],
				showLines ? styles['lines'] : '',
				className,
				bold ? styles['bold'] : '',
				preFormatted ? styles['preFormatted'] : '',
			].join(' ')}
			style={style}
			gutterBottom={gutterBottom}
			textOverflow={textOverflow}
			{...rest}
		>
			{children || text}
		</Typography>
	);
};
